import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { OrderType, PharosPaginatedResponse } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { createOrderTypeApi, orderTypeKeys } from '../api';
import type { SearchOrderTypesParams } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UseOrderTypesOptions extends SearchOrderTypesParams {
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useOrderTypes(options?: UseOrderTypesOptions): UseQueryResult<PharosPaginatedResponse<OrderType>> {
  const { enabled = true, ...listParams } = options ?? {};
  const client = useApiClient('admin-auth');
  const api = createOrderTypeApi(client);

  return useQuery({
    enabled,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.searchOrderTypes(listParams),
    queryKey: orderTypeKeys.list(listParams),
    staleTime: LIST_STALE_TIME_MS,
  });
}
